<template lang="pug">
#info_by_qr_code
  #accordion.mb-5.mt-3
    .news_card.mb-4.mt-3.border-radius-10
      .row
        .col-12.px-0
          h5.text-center.pb-2 報名資訊
      .row.mt-3.position-relative
        .container.single
          .row.mb-5
            .col-md-6.left
              span.title 學生姓名
              input.form-control(
                required="true",
                type="text",
                placeholder="請輸入學生姓名",
                v-model="singleStudent.studentName"
              )
              span.title 聯絡人電話
              input.form-control(
                required="true",
                type="text",
                placeholder="請輸入您的聯絡電話",
                v-model="singleStudent.contactPhone"
              )
              span.title 就讀學校
              input.form-control(
                required="true",
                type="text",
                placeholder="請輸入學生就讀學校",
                v-model="singleStudent.school"
              )
              span.title 就讀年級
              input.form-control(
                required="true",
                type="text",
                placeholder="請輸入學生年級",
                v-model="singleStudent.grade"
              )
              span.title 出生年月日(保險用)
              input.form-control(
                required="true",
                type="text",
                placeholder="請輸入學生出生年月日",
                v-model="singleStudent.studentBirthday",
                @input="birthdayChange('S', singleStudent.studentBirthday, singleStudent)"
              )
              p.valid(v-if="singleStudent.birthdayValid") *請輸入正確的出生年月日 ex: 2000/01/01
              span.title 身份證字號(保險用)
              input.form-control(
                required="true",
                type="text",
                placeholder="請輸入學生身分證字號",
                v-model="singleStudent.studentID",
                maxlength="10",
                @input="personIdChange('S', singleStudent.studentID, singleStudent)"
              )
              p.valid(v-if="singleStudent.personIdValid") *請輸入正確的身分證字號
            .col-md-6.right
              span.title 法定代理人姓名(保險用)
              input.form-control(
                required="true",
                type="text",
                placeholder="請輸入法定代理人姓名",
                v-model="singleStudent.parentName"
              )
              span.title 法定代理人出生年月日(保險用)
              input.form-control(
                required="true",
                type="text",
                placeholder="請輸入法定代理人出生年月日",
                v-model="singleStudent.parentBirthday",
                @input="birthdayChange('P', singleStudent.parentBirthday, singleStudent)"
              )
              p.valid(v-if="singleStudent.parentBirthdayValid") *請輸入正確的出生年月日 ex: 2000/01/01
              span.title 法定代理人身分證字號(保險用)
              input.form-control(
                required="true",
                type="text",
                placeholder="請輸入法定代理人身分證字號",
                v-model="singleStudent.parentID",
                @input="personIdChange('P', singleStudent.parentID, singleStudent)"
              )
              p.valid(v-if="singleStudent.parentIdValid") *請輸入正確的身分證字號
              span.title 籃球學習經驗描述（參加過社團或其他籃球營隊）
              input.form-control(
                required="true",
                type="text",
                placeholder="請輸入學生的籃球學習經驗描述",
                v-model="singleStudent.basketball_experience"
              )
              span.title 課程主要目標
              input.form-control(
                required="true",
                type="text",
                placeholder="請輸入課程主要目標",
                v-model="singleStudent.basketball_goal"
              )
              span.title 如何得知訊息
              select.hear_from.form-control(
                placeholder="請選擇",
                v-model="singleStudent.contact_from"
              )
                option(value="NONE") 無
                option(value="FACEBOOK") Facebook
                option(value="INSTAGRAM") Instagram
                option(value="LINE") Line
                option(value="GOOGLE") Google搜尋
                option(value="FRIEND") 親友介紹
                option(value="OTHER") 其他
          .row.border-top
            .col-12
              span.title 聯絡人LINE帳號ID
              span.mt-1 (請務必打開ID並留下您的ID，會有專人向您確認報名資訊，如沒有打開ID視同放棄報名及優惠)
              input.form-control(
                required="true",
                type="text",
                placeholder="請輸入 LINE 帳號 ID",
                v-model="singleStudent.lineID"
              )
              span.title 健康狀況
              .radio_btn.mt-2.flex_h
                input(
                  type="radio",
                  name="healh",
                  value="遺傳疾病",
                  v-model="singleStudent.healthy"
                )
                span 遺傳疾病
              .radio_btn.flex_h
                input(
                  type="radio",
                  name="healh",
                  value="心臟疾病",
                  v-model="singleStudent.healthy"
                ) 
                span 心臟疾病
              .radio_btn.flex_h
                input(
                  type="radio",
                  name="healh",
                  value="氣喘",
                  v-model="singleStudent.healthy"
                ) 
                span 氣喘
              .radio_btn.flex_h
                input(
                  type="radio",
                  name="healh",
                  value="癲癇",
                  v-model="singleStudent.healthy"
                ) 
                span 癲癇
              .radio_btn.flex_h
                input(
                  type="radio",
                  name="healh",
                  value="無",
                  v-model="singleStudent.healthy"
                ) 
                span 無
              span.title 食物過敏(小朋友不能吃的及吃了會過敏的請註明，沒有請填無)
              input.form-control(
                required="true",
                type="text",
                v-model="singleStudent.allergy"
              )

    #accordion.mb-5.mt-3
      .news_card.mb-4.border-radius-10
        .row
          .col-12
            h4.text-center
        .row.mt-3.mt-md-0
          .p-3.border.rounded.w-100(v-html="productInfo")
        .row.mt-3
          .col-12.text-center
            h5.agree 您是否同意以上規範
              span
                input(type="checkbox", v-model="isAgree")
              span 同意
      .row.submit-btn.mt-3.justify-content-center
        .col-12.text-center
          .send_btn(@click="onConfirmBtnClick") 確認送出
  custom-footer
</template>

<script>
import CustomFooter from "@/components/common/Footer";
import { validID, validDateExist } from "@/utils/validate";
import { errorMessage } from "@/utils/message";
import { addStudent } from "@/api/ecommerce";
import crypto from "@/utils/crypto";

export default {
  name: "InfoByQRCode",

  components: {
    "custom-footer": CustomFooter,
  },
  data() {
    return {
      //---測試資料--//
      productInfo:
        "1.報名繳費後，請假、中途離班學費皆不得退費或轉讓。</br>2.線上課程需於當期使用完畢，未上完之課程，當期結束後視同放棄，不予補客。</br>3.報名前應衡量個人體能與心理狀況，如有心血管或心臟病、癲癇症、氣喘等疾病請勿報名參加、籃球運動偶爾會有輕微運動傷害，若有任何傷害或意外發生，TOP巔峰籃球訓練營之全體工作人員無須負擔任何任何投保以外的責任與義務。</br>4.上課期間不定期會有攝影師拍照，但不是每一堂都有，訓練營團隊有權將此活動之錄影、照片於世界各地播放、展出、登入於活動網站及刊物上，即參加學員必須同意肖像用於相關活動之宣傳與播放上。",
      //---測試資料--//

      isAgree: false,
      singleStudent: {
        studentName: "",
        studentBirthday: "",
        contactPhone: "",
        studentID: "",
        school: "",
        parentName: "",
        parentBirthday: "",
        parentID: "",
        grade: "",
        lineID: "",
        healthy: "",
        allergy: "",
        contact_from: "NONE",
        basketball_experience: "",
        basketball_goal: "",

        parentBirthdayValid: false,
        parentIdValid: false,
        birthdayValid: false,
        personIdValid: false,
      },
      order: {},
    };
  },
  created() {
    this.checkUrlStatus();
  },
  methods: {
    checkUrlStatus() {
      if (this.$route.query.token) {
        this.order = JSON.parse(
          crypto.decryptAES(this.$route.query.token, crypto.aesKey)
        );
      } else {
        errorMessage(this, "錯誤", "請使用正確的網址報名");
      }
    },
    checkOrderStatus() {
      let hasError = false;
      let errorMsg = "";
      if (!this.singleStudent.studentName) {
        hasError = true;
      }
      if (
        !this.singleStudent.studentBirthday ||
        this.singleStudent.birthdayValid
      ) {
        hasError = true;
      }
      if (!this.singleStudent.contactPhone) {
        hasError = true;
      }
      if (!this.singleStudent.studentID || this.singleStudent.personIdValid) {
        hasError = true;
      }
      if (!this.singleStudent.school) {
        hasError = true;
      }
      if (!this.singleStudent.basketball_experience) {
        hasError = true;
      }
      if (!this.singleStudent.basketball_goal) {
        hasError = true;
      }
      if (!this.singleStudent.parentName) {
        hasError = true;
      }
      if (
        !this.singleStudent.parentBirthday ||
        this.singleStudent.parentBirthdayValid
      ) {
        hasError = true;
      }
      if (!this.singleStudent.parentID || this.singleStudent.parentIdValid) {
        hasError = true;
      }
      if (!this.singleStudent.grade) {
        hasError = true;
      }
      if (!this.singleStudent.lineID) {
        hasError = true;
      }
      if (!this.singleStudent.healthy) {
        hasError = true;
      }
      if (!this.singleStudent.allergy) {
        hasError = true;
      }
      if (hasError) {
        errorMsg = errorMsg + "請將必填項目填寫完整";
      }

      if (!this.isAgree) {
        if (errorMsg) {
          errorMsg = errorMsg + ", 請勾選同意以上規範";
        } else {
          errorMsg = errorMsg + "請勾選同意以上規範";
        }
      }

      return errorMsg;
    },
    birthdayChange(type, birthday, student) {
      if ("S" == type) {
        if (validDateExist(birthday)) {
          student.birthdayValid = false;
        } else {
          student.birthdayValid = true;
        }
      } else {
        if (validDateExist(birthday)) {
          student.parentBirthdayValid = false;
        } else {
          student.parentBirthdayValid = true;
        }
      }
    },
    personIdChange(type, studentID, student) {
      let tempStudentID = studentID.toUpperCase();
      if ("S" == type) {
        if (validID(tempStudentID)) {
          student.personIdValid = false;
        } else {
          student.personIdValid = true;
        }
      } else {
        if (validID(tempStudentID)) {
          student.parentIdValid = false;
        } else {
          student.parentIdValid = true;
        }
      }
    },
    onConfirmBtnClick() {
      let errorMsg = this.checkOrderStatus();
      if (errorMsg) {
        errorMessage(this, "警告", errorMsg);
        return;
      }

      let tempStudent = {
        name: this.singleStudent.studentName,
        citizen_id: this.singleStudent.studentID,
        birthday: this.singleStudent.studentBirthday,
        school: this.singleStudent.school,
        grade: this.singleStudent.grade,
        basketball_experience: this.singleStudent.basketball_experience,
        basketball_goal: this.singleStudent.basketball_goal,
        health_condition: this.singleStudent.healthy,
        food_allergens: this.singleStudent.allergy,
        legal_representative_name: this.singleStudent.parentName,
        legal_representative_birthday: this.singleStudent.parentBirthday,
        legal_representative_citizen_id: this.singleStudent.parentID,
        parent_phone: this.singleStudent.contactPhone,
        parent_line_id: this.singleStudent.lineID,
      };

      let data = {
        user_email: this.order.email,
        program_order: this.order.orderID,
        program_apply_target: tempStudent,
      };
      addStudent(data)
        .then(() => {
          this.$router.push({ name: "Home" });
        })
        .catch((error) => {
          errorMessage(this, "報名失敗", error.response.data.error_msg);
        });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/enroll/enroll";
</style>
